<app-dialog-heading [heading]="'Rule Messages'"></app-dialog-heading>

<div class="flex justify-center items-center">
  <div class="w-25">
    <mat-form-field>
      <mat-label>Rule Status</mat-label>
      <mat-select [value]="'1'" (selectionChange)="onStatusSelectionChange($event.source.value)">
        <mat-option value="-1">All Rules</mat-option>
        <mat-option value="1">Active Rules</mat-option>
        <mat-option value="0">Inactive Rules</mat-option>
      </mat-select>
    </mat-form-field>
  </div>
  <div>
    <app-content-field
      [label]="'Application Stage'"
      [content]="stage">
    </app-content-field>
  </div>
  
  <div class="flex items-center m-r-10">
    <app-content-field
      [label]="'Application Status'"
      [content]="status">
    </app-content-field>
    <greydom-status-indicator class="mt1" [fillColor]="getStatusColor(statusForIndicator)"></greydom-status-indicator>
  </div>
</div>

<div class="dialog-content" style="max-height: 80vh">
  <table mat-table [dataSource]="dataSource" matSort>
    <ng-container [matColumnDef]="tableColumns.ApplicationPersonId">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Person Name</th>
      <td mat-cell *matCellDef="let row">{{(row.displayPersonName)}}</td>
    </ng-container>
    
    <ng-container [matColumnDef]="tableColumns.RuleNumber">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Rule Number</th>
      <td mat-cell *matCellDef="let row">{{row.ruleNumber}}</td>
    </ng-container>

    <ng-container [matColumnDef]="tableColumns.RulePackage">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Rule Package</th>
      <td mat-cell *matCellDef="let row">{{row.rulePackage}}</td>
    </ng-container>

    <ng-container [matColumnDef]="tableColumns.ReasonCode">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Reason Code</th>
      <td mat-cell *matCellDef="let row">{{row.reasonCode}}</td>
    </ng-container>

    <ng-container [matColumnDef]="tableColumns.ReasonDescription">
      <th mat-header-cell *matHeaderCellDef mat-sort-header class="w-40">Reason Description</th>
      <td mat-cell *matCellDef="let row">{{row.reasonDescription}}</td>
    </ng-container>

    <ng-container [matColumnDef]="tableColumns.ActionCode">
      <th mat-header-cell *matHeaderCellDef mat-sort-header class="w-10">Action Code</th>
      <td mat-cell *matCellDef="let row">
        <div class="flex justify-start">
          <greydom-status-indicator *ngIf="getActionCodeColour(row?.actionCode)"
                                    [fillColor]="getActionCodeColour(row.actionCode)"></greydom-status-indicator>
          <span class="m-l-5">{{row.actionCode}}</span>
        </div>
      </td>
    </ng-container>

    <ng-container [matColumnDef]="tableColumns.OverrideIndicator">
      <th mat-header-cell *matHeaderCellDef mat-sort-header class="w-10">Override</th>
      <td mat-cell *matCellDef="let row">{{row.overrideIndicator ? 'Yes' : 'No'}}</td>
    </ng-container>

    <ng-container [matColumnDef]="tableColumns.LastFired">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Last Fired</th>
      <td mat-cell *matCellDef="let row">{{coalesce(row.updated, row.created) | date:dateFormat}}</td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>

  <mat-paginator [pageSize]="tableControl.pageSize"
                 [pageSizeOptions]="tableControl.pageSizeOptions"
                 [length]="tableControl.length">
  </mat-paginator>

  <mat-dialog-actions align="center" class="dialog-button-container">
    <button class="dialog-button" mat-raised-button color="primary" (click)="onCloseClick()">Close</button>
    <button *ngIf="showDownloadButton" mat-raised-button color="primary" (click)="onGenerateReportClick()">
      <mat-icon>download</mat-icon>
      Generate Report
      <app-busy-spinner-icon [isBusyCounter]="isBusyCounterInlineSpinner"></app-busy-spinner-icon>
    </button>
  </mat-dialog-actions>
</div>
